<template>
    <van-tabs type="card" v-model="active" class="xmlist">
        <van-tab :title="$t('prolist.m1title')">
            <van-row class="tabcont" v-for="(item,index) in list.shortTerm" :key="index">
                <RouterLink :to="`/Details?id=${item.id}`">
                    <van-col span="24">
                        <van-row>
                            <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                            <van-col span="6"></van-col>
                        </van-row>
                        <van-row class="list_middle">
                            <van-col span="7" class="rate">{{item.profitRate}}%</van-col>
                            <van-col span="7"></van-col>
                            <van-col span="10" class="buybtn"><van-tag color="#7232dd" class="tag">{{item.tag}}</van-tag></van-col>
                        </van-row>
                        <van-row>
                            <van-col span="7">{{ $t('index.rate' )}}</van-col>
                            <van-col span="10"></van-col>
                            <van-col span="7"></van-col>
                        </van-row>
                        <van-row>
                            <van-col span="24" class="comment"><span style="font-weight: bold">{{ $t('prolist.comment') }}</span> | {{item.comment}}</van-col>
                        </van-row>
                    </van-col>
                </RouterLink>
            </van-row>
        </van-tab>
        <van-tab :title="$t('prolist.m2title')">
            <van-row class="tabcont" v-for="(item,index) in list.steady" :key="index">
                <RouterLink :to="`/Details?id=${item.id}`">
                    <van-col span="24">
                        <van-row>
                            <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                            <van-col span="6"></van-col>
                        </van-row>
                        <van-row class="list_middle">
                            <van-col span="7" class="rate">{{item.profitRate}}%</van-col>
                            <van-col span="7"></van-col>
                            <van-col span="10" class="buybtn"><van-tag color="#7232dd" class="tag">{{item.tag}}</van-tag></van-col>
                        </van-row>
                        <van-row>
                            <van-col span="7">{{ $t('index.rate' )}}</van-col>
                            <van-col span="10"></van-col>
                            <van-col span="7"></van-col>
                        </van-row>
                        <van-row>
                            <van-col span="24" class="comment"><span style="font-weight: bold">{{ $t('prolist.comment') }}</span> | {{item.comment}}</van-col>
                        </van-row>
                    </van-col>
                </RouterLink>
            </van-row>
        </van-tab>
        <van-tab :title="$t('prolist.m3title')">
            <van-row class="tabcont" v-for="(item,index) in list.lead" :key="index">
                <RouterLink :to="`/Details?id=${item.id}`">
                    <van-col span="24">
                        <van-row>
                            <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                            <van-col span="6"></van-col>
                        </van-row>
                        <van-row class="list_middle">
                            <van-col span="7" class="rate">{{item.profitRate}}%</van-col>
                            <van-col span="7"></van-col>
                            <van-col span="10" class="buybtn"><van-tag color="#7232dd" class="tag">{{item.tag}}</van-tag></van-col>
                        </van-row>
                        <van-row>
                            <van-col span="7">{{ $t('index.rate' )}}</van-col>
                            <van-col span="10"></van-col>
                            <van-col span="7"></van-col>
                        </van-row>
                        <van-row>
                            <van-col span="24" class="comment"><span style="font-weight: bold">{{ $t('prolist.comment') }}</span> | {{item.comment}}</van-col>
                        </van-row>
                    </van-col>
                </RouterLink>
            </van-row>
        </van-tab>
    </van-tabs>
</template>

<script>
    export default {
        name: "Xmlist",
        data() {
            return {
                active: 0,
            };
        },
        props:['list']
    }
</script>

<style scoped lang="scss">
    .xmlist{
        overflow: hidden;
        text-align: left;
        width: 92%;
        margin: 0 auto 10px auto;
        padding-top: 10px;
        border-radius: 10px;
        background: white;
        a{
            color: #666666;
        }
        .tabcont{
            margin: 10px;
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;
            .tab_tit{
                color: #666;
                font-size: 16px;
                font-weight: bold;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .list_middle{
                height: 35px;
                line-height: 35px;
                width: 100%;
                .rate{
                    height: 35px;
                    line-height: 35px;
                    color: red;
                    font-size: 19px;
                    font-weight: bold;

                }
                .buybtn{
                    text-align: right;
                    font-size: 14px;
                    font-weight: bold;
                   .tag{
                       padding: 5px;
                   }
                }
            }
            .comment{
                margin: 5px auto 0 auto;
                background: #ececec url("~@/assets/images/ic_comment.png")no-repeat left 10%;
                background-size: 9% 60%;
                padding: 5px;
                border-radius: 5px;
            }
        }
    }
</style>
